import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import ContactForm from '../../mixins/ContactForm';
import Form from '../../utils/Form';
import { makeFormData, simpleObjectCopy } from '../../utils/miscellanea';
import { State } from '../../utils/fetch';
import { success, warning } from '../../utils/Toast';
import * as basicLightbox from 'basiclightbox';
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock';
import Event from '../../utils/Event';
import { delay } from '../../utils/async';

const template = `
  <div class="pp">
    <div class="pp__close menu__sndw  menu__sndw--active" @click="$emit('close')"></div>
    <div class="pp__title">
      Оставьте свои контактные данные, <span>и мы вышлем вам наше предложение</span>
    </div>
    <div class="pp__form form form--th2">
      <div class="form__ctrl ">
        <input
          type="text" placeholder="Ваше имя*" class="form__input"
          v-model="form.data.name"
          :class="{'form__input--error': form.errors.has('name')}"
        >
      </div>
      <div class="form__ctrl">
        <input
          type="text" placeholder="Город/регион*" class="form__input"
          v-model="form.data.city"
          :class="{'form__input--error': form.errors.has('city')}"
        >
      </div>
      <div class="form__ctrl">
        <input
          type="text" placeholder="Телефон" class="form__input"
          v-model="form.data.phone"
          :class="{'form__input--error': form.errors.has('phone')}"
        >
      </div>
      <div class="form__ctrl">
        <input
          type="text" placeholder="Е-мейл*" class="form__input"
          v-model="form.data.email"
          :class="{'form__input--error': form.errors.has('email')}"
        >
      </div>
      
      <div class="row ">
        <div class="col-12-6 col-ts-12-12">
          <div class="form__ctrl">
            <label
              class="checkbox"
              :class="{'checkbox--error': form.errors.has('agreement')}"
            >
              <input type="checkbox" v-model="form.data.agreement">
              <span>
                <sup>
                  Согласие на обработку<br> <a href="#" @click.stop.prevent="openAgreement">персональных данных</a>
                </sup>
              </span>
            </label>
          </div>
        </div>
        <div class="col-12-6 col-ts-12-12">
          <div class="form__ctrl" @click="send">
            <div class="form__btn"><span>Отправить</span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
`;

interface ContactData {
  name: string;
  phone: string;
  email: string;
  city: string;
  company: string;
  agreement: boolean;
}

@Component({
  template: template,
})
export default class FormRequestKP extends mixins(ContactForm) {

  public form = new Form<ContactData>({
    city: '',
    name: '',
    phone: '',
    company: '',
    email: '',
    agreement: false
  });

  protected requiredFields = ['name', 'city', 'email', 'agreement'];
  private lbInstance!: basicLightbox.BasicLightBox | null;

  public async send() {
    this.checkForm();

    if (!this.isFormReady) return;

    this.isLoading = true;
    await delay(10000);

    const form = makeFormData(simpleObjectCopy(this.form.data));
    form.append(this._token, '1');
    form.append('type', '2');

    const response = await this._http.fetchJSON<any>(`/index.php?option=com_xcm&task=send_message`, {
      method: 'POST',
      body: form
    });

    this.isLoading = false;

    if (response.state == State.SUCCESS) {
      success('Сообщение отправлено');
      this.form.errors.clear();
      this.form.clear();
      location.href = '/ru/franchise/spasibo';
    } else {
      warning(response.message, 'Ошибка');
    }
  }

  async mounted() {
    Event.listen('close-agreement', () => {
      this.lbInstance?.close();
    });

    this._token = document.querySelector<HTMLElement>('#token')?.innerText || '';
  }

  openAgreement() {
    this.lbInstance = basicLightbox.create(
      document.querySelector(`#agreement`)!.innerHTML,
      {
        className: 'lb-th1',
        onShow: (_) => {
          disableBodyScroll(document.querySelector('.lb')!!);
          return true;
        },
        onClose: (_) => {
          clearAllBodyScrollLocks();
          return true;
        }
      }
    );

    this.lbInstance.show();
  }
}
